(function () {
  function getColumnCount(grid) {
    var setting = parseInt(getComputedStyle(grid).getPropertyValue('--field-notes-columns'), 10);
    if (Number.isNaN(setting) || setting < 1) setting = 2;
    if (window.matchMedia('(min-width: 990px)').matches) return setting;
    if (window.matchMedia('(min-width: 750px)').matches) return Math.min(2, setting);
    return 1;
  }

  function getItems(grid) {
    return Array.from(grid.querySelectorAll('.article')).sort(function (a, b) {
      return Number(a.dataset.masonryIndex) - Number(b.dataset.masonryIndex);
    });
  }

  function pack(grid) {
    if (!grid) return;

    var items = getItems(grid);
    var colCount = getColumnCount(grid);
    if (String(grid.dataset.masonryCols) === String(colCount) && grid.querySelector('.field-notes-blog__column')) {
      return;
    }

    items.forEach(function (item) {
      grid.appendChild(item);
    });
    grid.querySelectorAll(':scope > .field-notes-blog__column').forEach(function (column) {
      column.remove();
    });

    items.forEach(function (item) {
      item.style.gridRowEnd = '';
    });

    grid.dataset.masonryCols = String(colCount);

    if (colCount <= 1) {
      grid.classList.remove('is-packed');
      return;
    }

    var gap = getComputedStyle(grid).columnGap || '0px';
    var width = 'calc((100% - (' + (colCount - 1) + ' * ' + gap + ')) / ' + colCount + ')';

    var columns = [];
    for (var i = 0; i < colCount; i++) {
      var column = document.createElement('div');
      column.className = 'field-notes-blog__column';
      column.style.width = width;
      grid.appendChild(column);
      columns.push(column);
    }

    items.forEach(function (item, index) {
      columns[index % colCount].appendChild(item);
    });

    grid.classList.add('is-packed');
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('.field-notes-blog .blog-articles:not(.blog-articles--collage)').forEach(function (grid) {
      pack(grid);
    });
  }

  function announce(status, message) {
    if (!status) return;
    status.textContent = message;
  }

  var MIN_LOADING_DURATION = 1500;
  var sectionCache = new Map();

  function fetchSection(url, sectionId) {
    var start = Date.now();
    var target = new URL(url, window.location.origin);
    target.searchParams.set('section_id', sectionId);
    var key = target.toString();

    var html = sectionCache.has(key)
      ? Promise.resolve(sectionCache.get(key))
      : fetch(target)
          .then(function (response) {
            if (!response.ok) throw new Error('Request failed with status ' + response.status);
            return response.text();
          })
          .then(function (text) {
            sectionCache.set(key, text);
            return text;
          });

    return html.then(function (text) {
      var doc = new DOMParser().parseFromString(text, 'text/html');
      var remaining = MIN_LOADING_DURATION - (Date.now() - start);
      if (remaining <= 0) return doc;
      return new Promise(function (resolve) {
        setTimeout(function () {
          resolve(doc);
        }, remaining);
      });
    });
  }

  function loadMore(button) {
    if (!button || button.dataset.loading === 'true') return;

    var nextUrl = button.dataset.nextUrl;
    var sectionId = button.dataset.sectionId;
    var grid = document.getElementById(button.dataset.target);
    var wrapper = button.closest('[data-field-notes-load-more]');
    var status = wrapper ? wrapper.querySelector('[data-field-notes-status]') : null;
    if (!nextUrl || !grid) return;

    button.dataset.loading = 'true';
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    fetchSection(nextUrl, sectionId)
      .then(function (doc) {
        var newArticles = doc.querySelectorAll('.blog-articles .article');
        var newButton = doc.querySelector('[data-field-notes-load-more] .field-notes-blog__load-more-button');

        var firstNew = null;
        newArticles.forEach(function (article) {
          if (!firstNew) firstNew = article;
          grid.appendChild(article);
        });

        grid.dataset.masonryCols = '';
        init(grid.closest('.field-notes-blog'));

        if (newButton) {
          button.href = newButton.getAttribute('href');
          button.dataset.nextUrl = newButton.dataset.nextUrl;
        } else if (wrapper) {
          wrapper.remove();
        }

        announce(status, newArticles.length + ' more posts loaded');

        if (firstNew) {
          firstNew.setAttribute('tabindex', '-1');
          firstNew.focus();
        }
      })
      .catch(function (error) {
        console.error('Field notes load more failed:', error);
      })
      .finally(function () {
        button.dataset.loading = 'false';
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      });
  }

  function filterByTag(link) {
    var root = link.closest('.field-notes-blog');
    var sectionId = root ? root.dataset.fieldNotesSection : null;
    var wrapper = root ? root.querySelector('.field-notes-blog__articles-inner') : null;
    if (!root || !sectionId || !wrapper) return;

    if (link.getAttribute('aria-current') === 'page') return;
    if (wrapper.dataset.loading === 'true') return;

    var status = root.querySelector('[data-field-notes-tag-status]');

    wrapper.dataset.loading = 'true';
    wrapper.classList.add('is-loading');
    wrapper.setAttribute('aria-busy', 'true');

    fetchSection(link.href, sectionId)
      .then(function (doc) {
        var newWrapper = doc.querySelector('.field-notes-blog__articles-inner');
        if (!newWrapper) throw new Error('Field notes articles wrapper not found in response');

        wrapper.innerHTML = newWrapper.innerHTML;

        root.querySelectorAll('.field-notes-blog__tags-list li').forEach(function (li) {
          li.classList.remove('is-active');
          var a = li.querySelector('a');
          if (a) a.removeAttribute('aria-current');
        });
        link.closest('li').classList.add('is-active');
        link.setAttribute('aria-current', 'page');

        init(root);

        var count = wrapper.querySelectorAll('.blog-articles .article').length;
        announce(status, count + ' posts loaded');
      })
      .catch(function (error) {
        console.error('Field notes tag filter failed:', error);
        window.location.href = link.href;
      })
      .finally(function () {
        wrapper.dataset.loading = 'false';
        wrapper.classList.remove('is-loading');
        wrapper.removeAttribute('aria-busy');
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  window.addEventListener('resize', function () {
    init();
  });

  document.addEventListener('shopify:section:load', function (event) {
    sectionCache.clear();
    init(event.target);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.field-notes-blog__load-more-button');
    if (button) {
      event.preventDefault();
      loadMore(button);
      return;
    }

    var tagLink = event.target.closest('.field-notes-blog__tags a');
    if (tagLink && !tagLink.hasAttribute('data-field-notes-tag-exclude')) {
      event.preventDefault();
      filterByTag(tagLink);
    }
  });
})();
